import { RouteConfig, ModalRoute } from '../types/routes';
import Landing from '../pages/landing';
import DataGridFuture from '../components/datagrid.future';
import DataGridAll from '../components/datagrid.all';
import Reports from '../pages/reports';
import Dashboard from '../pages/dashboard';
import POS from '../pages/pos';
import DataGridPurchases from '../components/datagrid.purchases';
import Users from '../components/users';
import Commissions from '../components/commissions';
import FeatureRequest from '../components/FeatureRequest';
import EventRequest from '../components/EventRequest';

export const mainRoutes: RouteConfig[] = [
  {
    label: 'Dashboard',
    element: Landing as any,
    children: [{ 
      index: true, 
      element: Dashboard,
      path: 'dashboard',
      label: 'Dashboard' 
    },
      { path: 'upcoming-events', label: 'Upcoming Events', element: DataGridFuture },
      { path: 'all-events', label: 'All Events', element: DataGridAll },
      { path: 'reports', label: 'Reports', element: Reports },
      { path: 'sell-inventory', label: 'Sell Inventory', element: POS },
      { path: 'purchases', label: 'Purchases', element: DataGridPurchases },
    ],
    requiresAuth: true,
  },
];

export const modalRoutes: Record<string, ModalRoute> = {
  users: { component: Users, title: 'User Management', requiresAdmin: true },
  commissions: { component: Commissions, title: 'Commission Management', requiresAdmin: true },
  'feature-request': { component: FeatureRequest, title: 'Feature Request', requiresAdmin: false },
  'event-request': { component: EventRequest, title: 'Event Request', requiresAdmin: false }
};